import { NONE_ORDER_KEY } from "../../src/Config"
const RESTOCKER_CART_ID = `shelf-restocker-track`
const STORE_CREW = "auto-tagged-as-store-crew"

/**
 * Checks if a cartId is the restocker cartId
 * @param {string} cartId The cartId to check
 */
const isRestockerCartId = (cartId: string) => cartId === RESTOCKER_CART_ID

const getRearrangedOrders = (
  orders: string[],
  candidateOrders: string[],
  restockerCamera: string | null
) => {
  orders = orders.filter((item: any) => item !== NONE_ORDER_KEY)
  //For checking if restocker is already there in candidates track
  let isFoundRestocker = false
  let isFoundStoreCrew = false
  let candidateOrderList = [...candidateOrders]
  let otherOrderList: string[] = []
  orders.forEach((orderId: string) => {
    if (!candidateOrderList.includes(orderId)) {
      otherOrderList.push(orderId)
    }
  })
  candidateOrderList.forEach((orderId, index) => {
    const isStoreCrew = orderId === "auto-tagged-as-store-crew"
    if (isRestockerCartId(orderId)) {
      isFoundRestocker = true
      candidateOrderList.splice(index, 1)
      candidateOrderList.unshift(orderId)
    }
    if (isStoreCrew) {
      isFoundStoreCrew = true
      candidateOrderList.splice(index, 1)
      candidateOrderList.unshift(orderId)
    }
  })
  if (!isFoundRestocker && restockerCamera) {
    otherOrderList = [RESTOCKER_CART_ID, ...otherOrderList]
    isFoundRestocker = true
  }
  if (!isFoundStoreCrew) {
    otherOrderList = [STORE_CREW, ...otherOrderList]
    isFoundStoreCrew = true
  }
  otherOrderList = [NONE_ORDER_KEY, ...otherOrderList]
  return {
    candidateOrderList: candidateOrderList,
    otherCandidateOrderList: otherOrderList,
    allOrders: [...candidateOrderList, ...otherOrderList],
  }
}

export { RESTOCKER_CART_ID, isRestockerCartId, getRearrangedOrders }
